// Styles for CardFeatureRow go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledCardFeatureRow = styled.div`
  .feature {
    &-header {
      background: ${baseVariables.color.memberSolidAlt};
      border: ${toRem(1)} solid ${baseVariables.color.neutral20};
    }
    &-icon {
      cursor: pointer;
    }
    &-item {
      min-height: ${toRem(16)};
    }
  }
  .nerd-wallet-image,
  .nerd-wallet-mobile-image {
    width: ${toRem(176)};
    height: ${toRem(49)};
    margin: ${toRem(24)} auto;
    display: flex;
  }
  .nerd-wallet-mobile-image {
    width: ${toRem(96)};
    height: ${toRem(148)};
  }
`;
